<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">{{ alertObject.title | term }}</p>
      </header>
      <section class="modal-card-body">
        <p>{{ alertObject.text | term }} <b v-if="alertObject.extra">{{ alertObject.extra }}</b></p>
      </section>
      <footer class="modal-card-foot is-flex-end">
        <button class="button" type="button" @click="cancel">{{ 'cancel' | term }}</button>
        <b-button type="button is-danger" :loading="isWorking" @click="confirm">{{ 'delete' | term }}</b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'AlertComponent',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isWorking: {
      type: Boolean,
      default: false
    },
    alertObject: {
      type: Object,
      default: () => {}
    },
    alertData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isModalActive: false
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm', this.alertData)
    }
  },
  watch: {
    isActive (newValue) {
      this.isModalActive = newValue
    },
    isModalActive (newValue) {
      if (!newValue) {
        this.cancel()
      }
    }
  }
}
</script>
